import { Paper as MuiPaper, Grid, styled } from "@mui/material";

const NonShadowPaper = styled(MuiPaper)`
  border-radius: 12px;
  margin: 10px 0;
  padding: 15px;
`;

export default function Paper({
  gridSpacing,
  variant,
  noGrid,
  gridProps,
  ...props
}) {
  return (
    <NonShadowPaper
      slotProps={{
        paper: {
          sx: {
            borderRadius: "12px",
          },
        },
      }}
      p="25px"
      variant={variant}
      {...props}
    >
      {Boolean(noGrid) ? (
        props.children
      ) : (
        <Grid
          container
          alignItems="flex-start"
          {...gridProps}
          spacing={Boolean(gridSpacing) ? gridSpacing : 4}
        >
          {props.children}
        </Grid>
      )}
    </NonShadowPaper>
  );
}
